// extracted by mini-css-extract-plugin
export default {"iconContainer":"ErrorScreen__iconContainer__YwqVF","iconContainerSmall":"ErrorScreen__iconContainerSmall__IVd6c","iconContainerFull":"ErrorScreen__iconContainerFull__ZfPw2","buttonContainer":"ErrorScreen__buttonContainer__aMzhr"};
    if(module.hot) {
      // 1754055607101
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  